import React, { useState, useEffect } from 'react';
import validate from 'validate.js';

import { Coins as CoinIcon} from "theme/icon";
const schema = {
    name: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 100
        }
    },
}

// const Coin = (props) => {
function Coin(props) {
    const [open, setOpen] = React.useState(false);
     const handleClickOpen = () => {
        setOpen(!open);
        // setValues({
        //     ...values,
        //     text: (props.item && props.item.text) || ""
        // });style={{ "display": "flex", "justifyContent": "space-between", "marginTop": "5px" }}
    }

    return (
        <React.Fragment>
            <span  className="icon-button" onClick={handleClickOpen} style={{}}>
                           <CoinIcon size={20}/>
            </span>
            { open && (
            <div onClose={props.handleClose} className='dialog'>
                     <div className='dialog-content'>
                    
                    <div className='dialog-title'> Summary Coin</div>
                    <div className='dialog-subtitle' >
                        Incoming and outgoing coins
                    </div>
                    <div className='divider' />
                    <div style={{}}>
                        <div style={{ "display": "flex", "justifyContent": "space-between", "marginTop": "5px" }}>
                            <span> Incoming: </span> <span style={{ "fontWeight": "bold" }}>0</span>
                        </div>
                        <div style={{ "display": "flex", "justifyContent": "space-between", "marginTop": "5px" }}>
                            <span>Outgoing: </span> <span style={{ "fontWeight": "bold" }}>0</span>
                        </div>
                        <div style={{ "display": "flex", "justifyContent": "space-between", "marginTop": "5px" }}>
                            <span>Total: </span><span style={{ "fontWeight": "bold" }}>0</span>
                        </div>
                    </div>
                
                <div className='dialog-actions'>
                    <button onClick={handleClickOpen} className='btn btn-primary'>Close</button>
                </div>
            </div>
            </div>
            )}
         </React.Fragment>
    );
}

export default Coin;

/**
 *  <Button variant="text" onClick={handleClickOpen}>
                Add List
            </Button>
 */
